import { useEffect } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { trackPageView } from '@/utils/analytics';

/**
 * RouteTracker Component
 *
 * Automatically tracks page views in Google Analytics 4 whenever the route changes.
 * This component should be used as a layout wrapper in the router configuration.
 *
 * Features:
 * - Tracks page path and title on every route change
 * - Integrates seamlessly with React Router
 * - Respects GA4 initialization state
 */

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);

  // Render child routes through Outlet
  return <Outlet />;
};

export default RouteTracker;
